import type { MaybeRef } from '../../types';
import { Decisions, features } from '../../utils/toggles';

type UseFeatureOptions = {
  scope?: number;
};

export const useFeature = (
  decision: MaybeRef<Decisions>,
  options?: UseFeatureOptions,
) => {
  const { scope = 1 } = options || {};
  const isEnabled = computed(() => features.isScopeEnabled(toValue(decision), scope));

  return {
    isEnabled,
  };
};
